import { List, Map } from 'immutable'
import { Action, any, browserRouter, Fun, nothing, Option, Pair, unloadedAsyncState, Widget, mk_pair, some, IOWidget, AsyncState } from 'widgets-for-react'
import { Block } from '../wordpress/types_and_parser/standard_blocks.gen'
import { BlocksRenderer } from '../cms/blocks/block_to_widget.gen'
import { Breadcrumb } from '../wordpress/types_and_parser/extra_types.mod'
import { defaultPage, HeaderState, ContentType, emptyAppState, PublicSiteState, OptionsState } from '../public_site.main.mod'
import { EntryClient } from '../cms/widget.gen'
import { ExtraImages } from './utils/extra_images.mod'
import { pageDisplay } from './blocks/renderer.mod'
import { PageStateZero } from '../cms/state/utils.gen'
import { PageTemplateState, AppState } from '../cms/state/types.gen'
import { ParsedNode } from '../wordpress/types_and_parser/types.ext.gen'
import { PublicSiteCustomRoutes, CustomPages } from './custom_pages/types.mod'
import { WordPressBlock_To_WidgetBlock } from '../wordpress/wordpress_to_cms.gen'
import { WordPressBlockImagesLoader } from '../wordpress/rendering/image_utils.mod'
import { CustomBlock } from '../wordpress/types_and_parser/custom_blocks.mod'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { history } from './templates/history.mod'
import { CloseVideoOrHeader, unescapeHTML, closeSearchAndMenu } from '../../utils'
import { CustomBlock_To_Widget } from './CustomBlockToWidget'
import { Entity } from 'ts-lenses'
import { footerAnimFrameId } from './templates/footer.mod'
import { homeAnimFrameId } from './custom_pages/Fc150YearsWidget/widgets/HomeWidget'
import { themesAnimFrameId } from './custom_pages/Fc150YearsWidget/widgets/StoriesOverviewWidget'
import { WordPress } from '../wordpress/wordpress_api'
import { ExtraParameters } from '../cms/router/type.gen'

export const defaultLang: string = "en";
export let lang: string = defaultLang;
export const availableLanguages = [
  { short: 'nl', full: 'Nederlands' },
  { short: 'en', full: 'English' },
]

export type PublicSite_CustomPageData = {
  posts: Map<number, AsyncState<WordPress.PostTypeResponse>>
  post: WordPress.PostTypeResponse
  latest_articles: AsyncState<Array<WordPress.PostTypeResponse>>
  news: WordPress.Overview<'news'>
  stories: WordPress.Overview<'story'>
  extra_params?: ExtraParameters
}


export const InitPagesStates: (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
) => PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState> = b => ({
  page: PageStateZero<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState>(
    () => unloadedAsyncState(),
    defaultPage,
    pageDisplay(b)
  ).page
})


export const application = (
  data: { rootpath: string; rootpath_to_ignore: string; login_address?: string },
  header: (s: PublicSiteState, _: HeaderState, o: OptionsState) => Widget<Action<HeaderState>>,
  footer: (
    _: AppState<PublicSiteState, PublicSiteCustomRoutes>
  ) => Widget<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>,
  errorPage: IOWidget<PublicSiteState, never>,
  loadingPage: Widget<never>,
  page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>,
  custom_pages: CustomPages
) => {
  lang = window.wp.language;
  let rootpath = data.rootpath ? data.rootpath : ''
  let rootpath_to_ignore = data.rootpath_to_ignore ? data.rootpath_to_ignore : ''

  return (s0: AppState<PublicSiteState, PublicSiteCustomRoutes>) => {
    return browserRouter<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
      s0.route.kind == 'ignore'
        ? nothing()
        : any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()([

          header(s0.state, s0.state.header, s0.state.options)
            .map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(a => s1 => Entity(s1).setIn('state', state => state.set('header', header => a(header))).commit()),


          EntryClient<
            CustomBlockData,
            CustomBlock,
            Block,
            PublicSiteState,
            keyof CustomPages,
            PublicSiteCustomRoutes,
            ExtraImages,
            PublicSite_CustomPageData
          >({
            initState: emptyAppState(page),
            custom_pages,
            StandardBlockImagesLoader: WordPressBlockImagesLoader,
            StandardBlock_To_Widget: WordPressBlock_To_WidgetBlock,
            errorPage: errorPage,
            loadingPage: loadingPage,
            rootpath: rootpath,
            rootpath_to_ignore: rootpath_to_ignore,
            CustomBlock_To_Widget: CustomBlock_To_Widget,
            CustomBLockImagesLoader: (c: CustomBlock) => []
          })(s0),

          footer(s0).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(a => s1 => a(s1)),

          history().map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(la => {
            // la.action == 'PUSH' && window.scrollTo(0, 0)
            la.action == 'PUSH'
            // Disable all animation frames on navigation
            cancelAnimationFrame(homeAnimFrameId);
            cancelAnimationFrame(themesAnimFrameId);
            cancelAnimationFrame(footerAnimFrameId);
            return closeSearchAndMenu
          }),

        ])
    ).map<AppState<PublicSiteState, PublicSiteCustomRoutes>>(a => {
      let s1 = a(s0)

      if (s1.state.page.page.kind == "loaded" && s0.state.page.page.kind != "loaded") {
        s1.state.page.display = page(mk_pair(List(), some(s1.state.page.page.value.extra_data.post)))
      }

      if (s0.route != s1.route) {
        s1 = closeSearchAndMenu(s1)
      }

      if (
        s1.state.page.page.kind == 'loaded' &&
        s1.state.page.page.value.extra_data.post.yoast &&
        s1.state.page.page.value.extra_data.post.yoast.title
      ) {
        document.title = unescapeHTML(s1.state.page.page.value.extra_data.post.yoast.title)
      }

      const docEl:HTMLElement = document.documentElement;

      if(!docEl.classList.contains('video--open')) {
        if (s1.state.header.menu == 'open') {
          docEl.classList.remove('menu--closing')
          docEl.classList.add('menu--opening')
          setTimeout(() => docEl.classList.add('menu--open'), 1000);
        } else {
          if (docEl.classList.contains('menu--open')) {
            docEl.classList.add('menu--closing')
            docEl.classList.remove('menu--opening')
            docEl.classList.remove('menu--open')
          }                    
        }
      } else {
        docEl.classList.add('video--closing');
        docEl.classList.remove('video--open');
        docEl.classList.remove('video--opening');
        s1 = CloseVideoOrHeader(s1)
      }

      if ((s1.state.Fc150YearsMainPage.current_page == 'homepage' && s1.state.Fc150YearsMainPage.homeState.splashState != "no-show" && s1.state.Fc150YearsMainPage.homeState.splashState != "wave-up")) {
        docEl.classList.add('splash--open');
      } else {
        docEl.classList.remove('splash--open');
      }

      if (s1.route != s0.route) {
        // Disable all animation frames on navigation
        cancelAnimationFrame(homeAnimFrameId);
        cancelAnimationFrame(themesAnimFrameId);
        cancelAnimationFrame(footerAnimFrameId);
        // document.getElementsByClassName("header")[0].scrollIntoView()
      }
      return s1
    })
  }
}
